import { Injectable } from '@angular/core';
import { FspBorderPointsGridDto } from './fsp-border-points-grid-data-model';
import { GridDataService } from '../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspBorderPointsGridDataService extends GridDataService<FspBorderPointsGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
